"use strict";
/**
 *
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var BaseService_1 = require("./BaseService");
var singleton_1 = require("./singleton");
var AppConfig_1 = require("./AppConfig");
var AuthenticationService_1 = require("./AuthenticationService");
var RtService = /** @class */ (function (_super) {
    __extends(RtService, _super);
    function RtService() {
        var _this = _super.call(this) || this;
        _this._dsSubscriptions = {};
        _this._connection = null;
        _this._session = null;
        _this._onConnected = function (session) {
            Object.keys(_this._dsSubscriptions).forEach(function (schemaName) {
                // when connected we are to subscribe each dataset
                var channelName = "lxbi.rt." + schemaName;
                _this._session.subscribe(channelName, function (args) { return _this._onReceivedDsRtMessages(schemaName, args); });
            });
        };
        _this._setModel({
            loading: true,
            error: null,
            connected: false
        });
        AuthenticationService_1.AuthenticationService.subscribeUpdatesAndNotify(function () { return _this._reload(); });
        // DEBUG
        if (typeof window !== 'undefined') {
            // usage: __debugUpdateVCP(dataset.schemaName, {"metric_id": ..., "loc_id": ..., "period_id": ..., "val": ...})
            window.__debugUpdateVCP = function (schemaName, mlpvPtr) {
                return _this._notifyDsRtMessages(schemaName, 'ADD_DATA', mlpvPtr);
            };
        }
        return _this;
    }
    RtService.prototype.subscribeDataset = function (schemaName, callback) {
        var _this = this;
        if (!(schemaName in this._dsSubscriptions)) {
            this._dsSubscriptions[schemaName] = [];
        }
        this._dsSubscriptions[schemaName].push(callback);
        if (this._session) {
            // const channelName: string = `com.luxms.bi.rt.update.${schemaName}.data`;
            var channelName = "lxbi.rt." + schemaName;
            this._session.subscribe(channelName, function (args) { return _this._onReceivedDsRtMessages(schemaName, args); });
        }
        return {
            dispose: function () {
                if (!(schemaName in _this._dsSubscriptions))
                    return;
                var idx = _this._dsSubscriptions[schemaName].indexOf(callback);
                if (idx !== -1) {
                    _this._dsSubscriptions[schemaName].splice(idx, 1);
                    if (_this._dsSubscriptions[schemaName].length === 0) {
                        delete _this._dsSubscriptions[schemaName];
                    }
                }
            }
        };
    };
    RtService.prototype.publishDsMessage = function (schemaName, type, payload) {
        if (!this._session) {
            // not connected
            return;
        }
        var channelName = "lxbi.rt." + schemaName;
        this._session.publish(channelName, [
            {
                type: type,
                payload: payload
            },
        ]);
    };
    RtService.prototype.onInternalDataUpdated = function (schemaName, mlpvPtrs) {
        this._notifyDsRtMessages(schemaName, 'ADD_DATAS', mlpvPtrs); // TODO: remove. Internal objects must listen to services, not Rt channel
        this.publishDsMessage(schemaName, 'ADD_DATAS', mlpvPtrs);
    };
    RtService.prototype._reload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authModel, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authModel = AuthenticationService_1.AuthenticationService.getModel();
                        if (authModel.error) {
                            this._disconnect();
                            this._setModel({
                                connected: false,
                                loading: false,
                                error: authModel.error
                            });
                            return [2 /*return*/];
                        }
                        if (authModel.loading) {
                            this._setModel({
                                loading: true,
                                error: null,
                                connected: false
                            });
                            return [2 /*return*/];
                        }
                        if (!authModel.authenticated) {
                            this._disconnect();
                            this._setModel({
                                loading: false,
                                error: AuthenticationService_1.AuthenticationService.NOT_AUTHENTICATED,
                                connected: false
                            });
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!!this._session) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._connect()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        debugger;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RtService.prototype._onReceivedDsRtMessages = function (schemaName, messages) {
        var _this = this;
        if (schemaName in this._dsSubscriptions) {
            messages.forEach(function (command) {
                var type = command.type, payload = command.payload;
                _this._notifyDsRtMessages(schemaName, type, payload);
            });
        }
    };
    RtService.prototype._notifyDsRtMessages = function (schemaName, type, payload) {
        var dsSubscriptionCallbacks = this._dsSubscriptions[schemaName];
        if (!dsSubscriptionCallbacks) {
            return;
        }
        dsSubscriptionCallbacks.forEach(function (dsSubscriptionCallback) {
            try {
                dsSubscriptionCallback(type, payload);
            }
            catch (err) {
                console.error('Error notifying callback', err);
            }
        });
    };
    RtService.prototype._connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Wampy, url, realm;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('wampy')); })];
                    case 1:
                        Wampy = (_a.sent()).Wampy;
                        url = AppConfig_1.AppConfig.fixRequestUrl('/srv/rt/');
                        if (url.startsWith('ws://')) {
                            // full url specified
                        }
                        else if (url[0] === '/') {
                            url = window.location.protocol + '//' + window.location.host + url;
                        }
                        else {
                            url =
                                window.location.protocol +
                                    '//' +
                                    window.location.host +
                                    window.location.pathname.replace(/[^/]*$/, '') +
                                    '/' +
                                    url.replace(/^\.\//, '');
                        }
                        url = url.replace(/^http/, 'ws');
                        realm = 'mi';
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                // this._connection = new autobahn.Connection({url, realm, use_es6_promises: true});
                                _this._connection = new Wampy(url, {
                                    realm: realm,
                                    onClose: function () { },
                                    onError: function () { },
                                    onReconnect: function () { },
                                    onConnect: function () {
                                        _this._session = _this._connection;
                                        // hack: server implementation error:
                                        if (!_this._session._cache.server_wamp_features.roles['broker'])
                                            _this._session._cache.server_wamp_features.roles['broker'] = {};
                                        _this._onConnected(_this._session);
                                        if (typeof window !== 'undefined') {
                                            window.__rt = _this._session;
                                            window.Ω = function (query) { return __awaiter(_this, void 0, void 0, function () {
                                                var r;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            if (Array.isArray(query)) {
                                                                query = query[0];
                                                            }
                                                            return [4 /*yield*/, this._session.call('lxbi.bins.dbAny', [query])];
                                                        case 1:
                                                            r = _a.sent();
                                                            console.table(r.rows);
                                                            window.ΩResponse = r;
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); };
                                        }
                                        resolve(_this._session);
                                    }
                                });
                                // this._connection.onopen = (session) => {
                                //   this._session = session;
                                //   this._onConnected(session);
                                //
                                //   // DEBUG
                                //   if (typeof window !== 'undefined') {
                                //     (window as any).__rt = session;
                                //     (window as any).Ω = async (query: any) => {
                                //       if (Array.isArray(query)) {
                                //         query = query[0];
                                //       }
                                //       const r: any = await this._session.call('lxbi.bins.dbAny', [query]);
                                //       console.table(r.rows);
                                //       (window as any).ΩResponse = r;
                                //     };
                                //   }
                                //
                                //   resolve(session);
                                // };
                                // this._connection.open();
                            })];
                    case 2:
                        _a.sent();
                        this._setModel({
                            connected: true,
                            error: null,
                            loading: false
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RtService.prototype._disconnect = function () {
        //
    };
    RtService.publishDsMessage = function (schemaName, type, payload) {
        this.getInstance().publishDsMessage(schemaName, type, payload);
    };
    RtService.getInstance = singleton_1.createSingleton(function () { return new RtService(); }, '__rtService');
    return RtService;
}(BaseService_1.BaseService));
exports.RtService = RtService;
